import { createApp } from 'vue'
import ZakuPosUploader from './zaku-pos-uploader.vue'
import i18nPlugin, { i18n, loadTranslations } from './i18n'

$.onmount('[data-vue=zaku-pos-uploader]', async function () {
  const props = JSON.parse(this.attributes['data-props'].value)
  const app = createApp(ZakuPosUploader, props)
  app.use(i18nPlugin)
  await loadTranslations(i18n)
  app.mount(this)
})
